/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
const i18n = require('js/app/core/i18n');

module.exports = i18n;
